/**
 * ChantierAddrBlock — bloc "adresse chantier différente" avec toggle + 3 inputs.
 * Extrait de QuoteEditorPage.jsx (Phase 3b refactor).
 */
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export default function ChantierAddrBlock({
  quote,
  setQuote,
  isDraft,
  showChantierAddr,
  setShowChantierAddr,
}) {
  const updateField = (field, value) =>
    setQuote({
      ...quote,
      chantier_address: { ...(quote.chantier_address || {}), [field]: value },
    });

  return (
    <>
      <div className="flex items-center gap-2">
        <Switch
          id="tg-chantier-addr"
          checked={showChantierAddr}
          onCheckedChange={setShowChantierAddr}
          disabled={!isDraft}
          data-testid="toggle-chantier-address"
        />
        <Label htmlFor="tg-chantier-addr" className="cursor-pointer text-sm text-slate-300">
          Adresse du chantier différente de l&apos;adresse de facturation
        </Label>
      </div>
      {showChantierAddr && (
        <div
          className="grid grid-cols-1 gap-2 rounded border border-slate-800 bg-slate-950/30 p-3 sm:grid-cols-3"
          data-testid="chantier-address-block"
        >
          <div>
            <Label className="text-[11px] text-slate-500">Rue</Label>
            <Input
              value={quote.chantier_address?.street || ""}
              onChange={(e) => updateField("street", e.target.value)}
              disabled={!isDraft}
              className="border-slate-700 bg-slate-950/40 text-slate-100"
              data-testid="chantier-address-street"
            />
          </div>
          <div>
            <Label className="text-[11px] text-slate-500">Code postal</Label>
            <Input
              value={quote.chantier_address?.zip || ""}
              onChange={(e) => updateField("zip", e.target.value)}
              disabled={!isDraft}
              className="border-slate-700 bg-slate-950/40 text-slate-100"
              data-testid="chantier-address-zip"
            />
          </div>
          <div>
            <Label className="text-[11px] text-slate-500">Ville</Label>
            <Input
              value={quote.chantier_address?.city || ""}
              onChange={(e) => updateField("city", e.target.value)}
              disabled={!isDraft}
              className="border-slate-700 bg-slate-950/40 text-slate-100"
              data-testid="chantier-address-city"
            />
          </div>
        </div>
      )}
    </>
  );
}
